<template>
  <v-dialog v-model="internalDialog" :max-width="$vuetify.display.mdAndDown ? undefined : '750px'" :fullscreen="$vuetify.display.mdAndDown" :scrim="!$vuetify.display.mdAndDown" @keydown.esc="close">
    <v-card :class="$vuetify.display.mdAndDown ? 'h-100 d-flex flex-column' : ''">
      <v-card-title class="title-modal">
        <span class="headline">DETALLE</span>
      </v-card-title>

      <v-card-text :class="$vuetify.display.mdAndDown ? 'flex-grow-1 overflow-auto' : ''">
        <v-row>
          <!-- Formulario principal -->
          <v-col cols="12">
            <v-form ref="form">
              <v-combobox
                v-model="item.product"
                name="product"
                item-title="label"
                item-value="id"
                :items="products"
                label="Producto*"
                autocomplete="off"
                :rules="[rules.requiredComboBox]"
                @update:modelValue="productSelected"
                clearable
              ></v-combobox>

              <!-- validar numerico -->
              <v-text-field
                v-if="item.product != null && item.product?.storage_unit?.id == productoService.STORAGE_UNITS_ID"
                autocomplete="off"
                name="amount"
                label="Cantidad*"
                type="text"
                v-model="item.amount"
                :rules="[rules.required]"
              />

              <v-combobox
                v-if="item.product != null && item.product.tiene_control_de_calidad"
                v-model="item.quality"
                name="quality"
                item-title="name"
                item-value="id"
                :items="qualities"
                label="Calidad*"
                autocomplete="off"
                :rules="[rules.requiredComboBox]"
                clearable
              ></v-combobox>

              <v-combobox
                v-if="item.product && item.product.tiene_control_por_lotes"
                v-model="item.lote"
                name="lote"
                item-title="name"
                item-value="id"
                :items="loteOptions"
                label="Lote"
                autocomplete="off"
                clearable
                :rules="[rules.onlySelectFromList]"
              ></v-combobox>

              <v-combobox
                v-if="item.product && item.product.tiene_control_por_serie"
                v-model="item.serie"
                name="serie"
                item-title="name"
                item-value="id"
                :items="serieOptions"
                label="Nº Serie"
                autocomplete="off"
                clearable
                :rules="[rules.onlySelectFromList]"
              ></v-combobox>

              <v-text-field
                v-if="item.product && isAliasEnabled('descriptivo_1') && item.product.tiene_control_por_descriptivo_1"
                autocomplete="off"
                name="descriptivo_1"
                :label="getAliasName('descriptivo_1')"
                type="text"
                v-model="item.descriptivo_1"
              />

              <v-text-field
                v-if="item.product && isAliasEnabled('descriptivo_2') && item.product.tiene_control_por_descriptivo_2"
                autocomplete="off"
                name="descriptivo_2"
                :label="getAliasName('descriptivo_2')"
                type="text"
                v-model="item.descriptivo_2"
              />

              <v-combobox
                v-if="item.product && isAliasEnabled('descriptivo_3') && item.product.tiene_control_por_descriptivo_3"
                v-model="item.descriptivo_3"
                name="descriptivo_3"
                item-title="name"
                item-value="id"
                :items="descriptivo_3Options"
                :label="getAliasName('descriptivo_3')"
                autocomplete="off"
                clearable
                :rules="[rules.onlySelectFromList]"
              ></v-combobox>

              <v-text-field
                v-if="item.product && item.product?.storage_unit?.id != productoService.STORAGE_UNITS_ID"
                autocomplete="off"
                name="storage_units_amount"
                label="Valor de almacenamiento*"
                type="number"
                v-model="item.storage_units_amount"
                :rules="[rules.required]"
              />

              <v-text-field
                v-if="item.product && item.product.requiere_fecha_expiracion"
                v-model="item.expiration_date"
                name="expiration_date"
                label="Fecha Minima de Expiración"
                scrollable
                type="date"
              ></v-text-field>

              <v-combobox
                v-model="item.product_status"
                name="product_status"
                item-title="name"
                item-value="id"
                :items="product_statuses"
                label="Estado del producto*"
                autocomplete="off"
                :rules="[rules.requiredComboBox]"
                clearable
              ></v-combobox>
            </v-form>
          </v-col>

          <!-- Panel de Stock -->
          <v-col cols="12" v-if="item.product">
            <v-card class="pt-0" elevation="0" style="border: 1px solid #c1c1c1; border-radius: 10px; padding: 10px">
              <v-progress-linear v-if="loading_stock" indeterminate size="20"></v-progress-linear>
              <v-card-title class="mt-2 text-h8">
                Stock
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-text>
                <div v-if="!loading_stock && stock_data && Object.keys(stock_data).length > 0">
                  <div class="d-flex align-center font-weight-bold">
                    <!-- Mostrar unidades -->
                    <div v-for="(stock, key) in stock_data" :key="key">
                      <template v-if="item.product?.storage_unit?.id == productoService.STORAGE_UNITS_ID && stock.presentation_type_id == productoService.PRESENTATION_TYPE_UNIDAD">
                        <div class="d-flex">
                          <div class="text-stock" style="min-width: 0px">
                            {{ stock.presentation_units }}
                          </div>
                          <div class="text-caption text-grey-600 flex-shrink-0 mt-1 presentation-type mr-3">
                            {{ getPresentationTypeName(stock.presentation_units, stock.presentation_type_id, stock.presentation_name) }}
                          </div>
                        </div>
                      </template>
                    </div>

                    <!-- Mostrar cajas -->
                    <div v-for="(stock, key) in stock_data" :key="'box-' + key">
                      <template
                        v-if="
                          item.product?.storage_unit?.id == productoService.STORAGE_UNITS_ID && stock.presentation_type_id == productoService.PRESENTATION_TYPE_CAJA && stock.presentation_units > 0
                        "
                      >
                        <v-tooltip location="bottom" :text="'Cajas'">
                          <template #activator="{ props }">
                            <v-chip size="small" v-bind="props" color="primary" class="text-caption font-weight-bold">
                              {{ stock.presentation_units }}
                              <font-awesome-icon icon="cube" class="ml-1" />
                            </v-chip>
                          </template>
                        </v-tooltip>
                      </template>
                    </div>

                    <!-- Mostrar Storage Amount -->
                     <div>
                      <template v-if="item.product?.storage_unit?.id != productoService.STORAGE_UNITS_ID">
                        <div class="d-flex">
                          <div class="text-stock" style="min-width: 0px">
                            <!-- se usa segun el tipo de presntacion: 1 unidad, 2 caja  -->
                            {{  stock_data[Object.keys(stock_data)[0]].storage_units_amount  }}
                          </div>
                          <div class="text-caption text-grey-600 flex-shrink-0 mt-1 presentation-type mr-3">
                            {{ stock_data[Object.keys(stock_data)[0]].storage_unit_name }}
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pa-4" :class="$vuetify.display.mdAndDown ? 'flex-shrink-0' : ''">
        <v-spacer></v-spacer>
        <v-btn color="red" :variant="'text'" @click="close">Cancelar</v-btn>
        <v-btn color="green" :variant="'text'" @click="addNewPresentation()" :class="$vuetify.display.mdAndDown ? 'px-6 ml-3' : ''">
          {{ itemEdit != null ? "Editar" : "Agregar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { productoService } from "@/libs/ws/productoService";
import { productQualityService } from "@/libs/ws/productQualityService";
import { inventoryService } from "@/libs/ws/inventoryService";
import ValidMixin from "@/mixins/ValidMixin.vue";
import AliasMixin from "@/mixins/AliasMixin.vue";
import GenericMixin from "@/mixins/GenericMixin.vue";

export default {
  mixins: [ValidMixin, AliasMixin, GenericMixin],
  props: {
    modelValue: Boolean, // reemplaza "dialog"
    shipment_order: Object,
    itemEdit: Object,
  },
  emits: ["update:modelValue", "addPresentation"],
  data: () => ({
    productoService,
    item: {
      product: null,
      amount: null,
      manufacture_date: null,
      expiration_date: null,
      lote: null,
      serie: null,
      descriptivo_1: null,
      descriptivo_2: null,
      descriptivo_3: null,
      storage_units_amount: null,
      quality: null,
      product_status: null,
      external_line_number: "",
    },
    defaultItem: {
      product: null,
      amount: null,
      manufacture_date: null,
      expiration_date: null,
      lote: null,
      serie: null,
      descriptivo_1: null,
      descriptivo_2: null,
      descriptivo_3: null,
      storage_units_amount: null,
      quality: null,
      product_status: null,
      external_line_number: "",
    },
    products: [],
    qualities: [],
    product_statuses: [],
    stock_data: {},
    loading_stock: false,
    loteOptions: [],
    serieOptions: [],
    descriptivo_3Options: [],
  }),
  computed: {
    internalDialog: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  watch: {
    modelValue(val) {
      if (val) {
        // Se abrió modal
        if (this.itemEdit == null) {
          this.item = JSON.parse(JSON.stringify(this.defaultItem));
          if (this.product_statuses.length > 0 && this.item.product_status == null) {
            this.item.product_status = this.product_statuses[0];
          }
        } else {
          this.item = JSON.parse(JSON.stringify(this.itemEdit));
        }
      } else {
        // Se cerró modal
        this.item = JSON.parse(JSON.stringify(this.defaultItem));
        this.stock_data = {};
        this.clearAttributeOptions();
      }
    },
    "item.quality"() {
      this.loadStock();
    },
    "item.lote"() {
      this.loadStock();
    },
    "item.serie"() {
      this.loadStock();
    },
    "item.descriptivo_1"() {
      this.loadStock();
    },
    "item.descriptivo_2"() {
      this.loadStock();
    },
    "item.descriptivo_3"() {
      this.loadStock();
    },
    "item.expiration_date"() {
      this.loadStock();
    },
    "item.storage_units_amount"() {
      this.loadStock();
    },
    "item.product_status"() {
      this.loadStock();
    },
  },
  mounted() {
    this.loadProducts();
    this.loadProductStatuses();
  },
  methods: {
    close() {
      this.internalDialog = false;
    },
    loadProducts() {
      let client = this.shipment_order.client ? this.shipment_order.client.id : null;
      // list_minify con detailed:true: query liviano (sin N+1 ni serializacion completa)
      // que trae las flags de control (lote/serie/calidad/descriptivos/expiracion) y
      // storage_unit que este modal necesita. Mucho mas rapido que filter/products/list.
      productoService.list_minify({ client, detailed: true }).then((response) => {
        this.products = response.result.list;
      });
    },
    loadProductStatuses() {
      productoService.getStates().then((response) => {
        if (response.status) {
          this.product_statuses = response.result.list;
          //set the first status as default
          if (response.result.list.length > 0 && this.item.product_status == null) {
            this.item.product_status = response.result.list[0];
          }
        }
      });
    },
    loadQualities() {
      productQualityService.filter({ product: this.item.product.id }).then((response) => {
        this.qualities = response.result.list;
      });
    },
    async loadProductAttributes() {
      if (!this.item.product) {
        this.clearAttributeOptions();
        return;
      }

      const productId = this.item.product.id;
      const almacenId = this.shipment_order.almacen?.id ?? null;

      try {
        if (this.item.product.tiene_control_por_lotes) {
          await this.loadAttributeOptions("lote", productId, almacenId);
        } else {
          this.loteOptions = [];
        }

        if (this.item.product.tiene_control_por_serie) {
          await this.loadAttributeOptions("serie", productId, almacenId);
        } else {
          this.serieOptions = [];
        }

        if (this.item.product.tiene_control_por_descriptivo_3) {
          await this.loadAttributeOptions("descriptivo_3", productId, almacenId);
        } else {
          this.descriptivo_3Options = [];
        }
      } catch (error) {
        console.error("Error cargando atributos del producto:", error);
      }
    },
    async loadAttributeOptions(attribute, productId, almacenId) {
      try {
        const params = {
          product_id: productId,
          attribute: attribute,
        };

        if (almacenId) {
          params.almacen_id = almacenId;
        }

        const response = await productoService.getProductAttributes(params);

        if (response.status) {
          const optionsProperty = `${attribute}Options`;
          this[optionsProperty] = response.result.list;
        }
      } catch (error) {
        console.error(`Error cargando opciones para ${attribute}:`, error);
        const optionsProperty = `${attribute}Options`;
        this[optionsProperty] = [];
      }
    },
    clearAttributeOptions() {
      this.loteOptions = [];
      this.serieOptions = [];
      this.descriptivo_3Options = [];
    },
    productSelected() {
      if (this.item.product != null) {
        this.loadStock();

        //Verificar si el producto es por Unidades o Peso
        if (this.item.product != null && this.item.product.storage_unit?.id != productoService.STORAGE_UNITS_ID) {
          this.item.amount = 1;
        } else {
          this.item.amount = null;
        }

        if (this.item.product.requiere_fecha_expiracion) {
          this.item.expiration_date = new Date().toISOString().split("T")[0];
        }
        if (this.item.product.tiene_control_de_calidad) this.loadQualities();

        this.loadProductAttributes();
      } else {
        this.qualities = [];
      }
    },
    async loadStock() {
      if (!this.item.product) {
        this.stock_data = {};
        return;
      }
      this.loading_stock = true;

      const params = {
        product_sku: this.item.product.sku,
        almacen_code: this.shipment_order.almacen ? this.shipment_order.almacen.code : null,
        client: this.shipment_order.client ? { id: this.shipment_order.client.id } : null,
      };

      if (this.item.quality && this.item.quality.id) params.quality = this.item.quality;
      if (this.item.lote) params.lote = typeof this.item.lote === 'object' ? this.item.lote.name : this.item.lote;
      if (this.item.serie) params.serie = typeof this.item.serie === 'object' ? this.item.serie.name : this.item.serie;
      if (this.item.descriptivo_1) params.descriptivo_1 = this.item.descriptivo_1;
      if (this.item.descriptivo_2) params.descriptivo_2 = this.item.descriptivo_2;
      if (this.item.descriptivo_3) params.descriptivo_3 = this.item.descriptivo_3.name || this.item.descriptivo_3;
      if (this.item.expiration_date) params.expiration_date = this.item.expiration_date;
      if (this.item.storage_units_amount) params.storage_units_amount = this.item.storage_units_amount;
      if (this.item.product_status) params.product_status = this.item.product_status.id;

      inventoryService
        .get_stock(params)
        .then((response) => {
          if (response.status) {            
            this.stock_data = response.result;
          }
        })
        .finally(() => {
          this.loading_stock = false;
        });
    },
    async addNewPresentation() {
      const { valid } = await this.$refs.form.validate();
      if (valid) {
        this.$emit("addPresentation", this.item);
        this.close();
      }
    },
  },
};
</script>
